// extracted by mini-css-extract-plugin
export var lg = "_4f-4";
export var md = "_4f-3";
export var sm = "_4f-2";
export var xs = "_4f-1";
export var xxs = "_4f-0";